import { render, staticRenderFns } from "./Adminshtg.vue?vue&type=template&id=1a7ca9fa&scoped=true&"
import script from "./Adminshtg.vue?vue&type=script&lang=js&"
export * from "./Adminshtg.vue?vue&type=script&lang=js&"
import style0 from "./Adminshtg.vue?vue&type=style&index=0&id=1a7ca9fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7ca9fa",
  null
  
)

export default component.exports